module.exports = __webpack_public_path__ + "static/bro5-b149cd3e0235cc7e4238997579e08942.jpg";